import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {IconClose} from "../../Icon";
import {t} from "i18next";
import {Button, Checkbox, ConfigProvider, message, Modal} from "antd";
import {getImagePathWithTheme, isArray, isDarkMode, isNoteElement} from "../../utils";
import {getNoteDocList, getNoteJsonDoc, getNoteList, updateNoteDoc} from "@model/note";
import newNote from "@/NewNote";
import {loopAllNodeAsync} from "@/TreeUtils";
import {isProjectLinkElement} from "../../../@excalidraw/packages/excalidraw/element/typeChecks";
import {getBoardById, updateBoard} from "@model/board";
import {postMessage} from "@/common/event";
import {EVENT_FAVIRIATE_CHANGE} from "@/Const";

const DialogMoveTo = forwardRef((props:{onCloseCallback:any}, ref) => {
    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog
    }))

    const [isShowDialog,setIsShowDialog] = useState(false);
    const [arrayProjects,setArrayProjects] = useState<any>([]);
    const [isRetainSelf,setIsRetainSelf] = useState(true);
    const [selectProject,setSelectProject] = useState(null);

    const mArrayProjects = useRef<any>(null);
    const mBoard = useRef(null);
    const mCallback = useRef(null);
    const mArrayNotes = useRef(null);
    const mszOldKey = useRef(null);
    const mProjectId = useRef(null);

    const onShowDialog = (board:any,szOldKey:any,notes:any,projectId:any,callback:any)=>{
        setIsShowDialog(true);
        mArrayNotes.current = notes;
        mCallback.current = callback;
        mBoard.current = board;
        mszOldKey.current = szOldKey;
        mProjectId.current = projectId;
    }

    useEffect(()=>{
        getNoteList().then(res=>{
            mArrayProjects.current = res;
            setArrayProjects(res);
        })
    },[])

    return(
        <ConfigProvider
            theme={{
                components: {

                    Modal: {
                        contentBg:'var(--dialog-dialog-background-color-2c)',
                        colorText:'var(--text-color)',
                        boxShadow:'var(--box-shadow-popover)'
                    },
                },
            }}>

            <Modal width={550} zIndex={2005} bodyStyle={{height:`${450}px`}}
                   afterClose={()=>{
                       props.onCloseCallback();
                   }}
                   open={isShowDialog} centered={true} closable={true} closeIcon={<IconClose/>} footer={null} onCancel={()=> {
                setIsShowDialog(false);
            }}>
                <div style={{height: '100%', width: '100%', display: 'flex', flexDirection: 'column'}}>
                    <div className={'flex-row-vertical-center'} style={{flexShrink: '0'}}>
                        <span className={'dialog-title'}>{t("Move to")}</span>
                        <div style={{flexGrow: '1'}}/>
                    </div>
                    <div className={'line mt-12'} style={{margin: '12px -22px'}}></div>
                    <input className={'input-border-1'}  onInput={(e)=>{
                        const szKey = e.currentTarget.value.toLowerCase();
                        if (!szKey) {
                            setArrayProjects([...mArrayProjects.current]);
                        }
                        const arrayNew = [];
                        for (let i=0;i<mArrayProjects.current.length;i++) {
                            const item = mArrayProjects.current[i];
                            if (!item.name)continue;
                            if (item?.name?.toLowerCase().includes(szKey)) {
                                arrayNew.push(item);
                            }
                        }
                        setArrayProjects(arrayNew);
                    }}
                           style={{border: 'none', borderRadius: '3px', marginBottom: '16px',backgroundColor:isDarkMode()?'#383838':'#efefef'}}
                           placeholder={t("Search projects")}/>
                    {/*margin:'0 -24px',padding:'0 24px'*/}
                    <div style={{height:'340px',overflow:'hidden auto',}}>
                        {
                            arrayProjects.map(p => {
                                return (
                                    <div className={'flex-row-vertical-center hovered-gray-radius-3'} onClick={()=>{
                                        const arrayNews = [...arrayProjects];
                                        arrayNews.forEach(p=>p.isSelected = false);
                                        p.isSelected = true;
                                        setArrayProjects(arrayNews);
                                        setSelectProject(p);
                                    }}
                                         onMouseEnter={()=>{
                                             const arrayNews = [...arrayProjects];
                                             arrayNews.forEach(p=>p.isChecked = false);
                                             p.isChecked = true;
                                             setArrayProjects(arrayNews);
                                         }}
                                         onMouseLeave={()=>{
                                             const arrayNews = [...arrayProjects];
                                             arrayNews.forEach(p=>p.isChecked = false);
                                             setArrayProjects(arrayNews);
                                         }}
                                         style={{height: '42px',borderRadius:'3px', padding: '0 8px',background:(p.isChecked || p.isSelected)?'var(--draw-tool-bar-selected-color)':'transparent'}}>
                                        <img className={'img-16'} src={getImagePathWithTheme('deeplink_project')}/>
                                        <span className={'ml-6'}>{p.name || t("Untitled")}</span>
                                    </div>
                                )
                            })
                        }
                    </div>

                    <div className={'flex-row-vertical-center mt-10'}>
                        <Checkbox style={{color:'var(--text-color)'}} checked={isRetainSelf} onChange={(e)=>setIsRetainSelf(!isRetainSelf)}>{t("DuplicateAndMove")}</Checkbox>
                        <div style={{marginLeft: 'auto'}}>
                            <Button
                                style={{height: '34px', minWidth: '120px'}}
                                className='large-w-button button-border-gray-style font-size-14 font-family-medium'
                                onClick={() => {
                                    setIsShowDialog(false);
                                }}>{t("Cancel")}</Button>
                            <Button
                                disabled={selectProject == null}
                                className='large-w-button button-solid-style font-size-14 font-family-medium'
                                type="primary"
                                onClick={async () => {
                                    //move to
                                    if (selectProject) {
                                        const projectDoc = await getNoteJsonDoc(selectProject.id);
                                        if (projectDoc && isArray(projectDoc.canvas)) {
                                            projectDoc.canvas.push(mBoard.current);
                                            //如果elements中有card,把card也存过来.
                                            //当前项目的所有note
                                            if (!isArray(projectDoc.notes)) {
                                                projectDoc.notes = [];
                                            }
                                            for (let i=0;i<mBoard.current?.drawJson.elements.length;i++) {
                                                const element = mBoard.current?.drawJson.elements[i];
                                                if (isNoteElement(element)) {
                                                    const hasExist = projectDoc.notes.some(p=>p.key == element.id || p.key == element.customData.generationData.id);
                                                    if (!hasExist) {
                                                        const note = mArrayNotes.current?.find(p=>p.key == element.id || p.key == element.customData.generationData.id);
                                                        if (note) {
                                                            const newNote = {...note};
                                                            newNote.icon = '';
                                                            projectDoc.notes.push(newNote);
                                                        }
                                                    }
                                                }
                                            }

                                            //保存一份到board表..
                                            const oldBoard = await getBoardById(mszOldKey.current)
                                            const newBoard = {
                                                id:mBoard.current?.key,
                                                name:mBoard.current?.title,
                                                projectId:selectProject.id,
                                                sort:oldBoard?.sort || 0,
                                                type:'board',
                                                tags:oldBoard?.tags,
                                                isFavirated:oldBoard?.isFavirated,
                                            }
                                            updateBoard(newBoard).then(res=>{
                                                //刷新...
                                                window.globalRefreshList('refresh_tableview_single_data_',newBoard.id,{type:'board'});
                                                postMessage(EVENT_FAVIRIATE_CHANGE);
                                            })

                                            //这个东西，要先转成字符串，然后再转回来保存。不然数据库报错？？类型不支持？？？？？
                                            let ssssss = JSON.stringify(projectDoc);
                                            //保存
                                            await updateNoteDoc({id:selectProject.id,doc:JSON.parse(ssssss)});
                                            //是否需要删除当前的这个...
                                            if (!isRetainSelf) {
                                                if (mCallback.current) {
                                                    mCallback.current('delete',selectProject);
                                                }

                                                //这里要更新这个画板在所有项目中的引用？////---搞得太麻烦了。
                                                getNoteDocList().then(async (res)=>{
                                                    for (let i=0;i<res.length;i++){
                                                        const doc = res[i];
                                                        if (!doc.doc)continue;
                                                        if (doc.id == mProjectId.current)continue;//当前的不能在这里处理，在别的地方.
                                                        let isUpdate = false;
                                                        await loopAllNodeAsync(doc.doc.canvas,async (canvas)=>{
                                                            if (canvas.drawJson?.elements){
                                                                for (let k=0;k<canvas.drawJson.elements.length;k++){
                                                                    const ele = canvas.drawJson.elements[k];
                                                                    if (isProjectLinkElement(ele)){
                                                                        if (ele.customData.projectId == mProjectId.current && ele.customData?.boardId == mszOldKey.current){
                                                                            ele.customData.projectId = selectProject.id;
                                                                            ele.customData.boardId = mBoard.current?.key;
                                                                            isUpdate = true;
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        })
                                                        if (isUpdate){
                                                            await updateNoteDoc(doc);
                                                        }
                                                    }
                                                })
                                            }


                                            setIsShowDialog(false);
                                            message.success(t("BoardMovedSuccess"))
                                        }
                                    }
                                }}
                                style={{
                                    marginLeft: '12px',
                                    minWidth: '120px'
                                }}
                                htmlType={"submit"}>{t("Confirm")}</Button>
                        </div>
                    </div>
                </div>
            </Modal>

        </ConfigProvider>

    )
})

export default (DialogMoveTo);